import React, { useEffect, useState } from 'react';
import MainLayout from '../../layouts/MainLayout';
import { useNavigate, useLocation, Link } from 'react-router-dom'; 
import { useSelector } from 'react-redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faPen, faTrash } from '@fortawesome/free-solid-svg-icons';

const MyFiveSMyList = ({ authStatr }) => {
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();
  const location = useLocation();
  const [userId, setUserId] = useState(authState.user._id);
  const [userName, setUserName] = useState(authState.user.name);
  const [userCode, setUserCode] = useState(authState.user.think5whyscode);
  const [fiveSList, setFiveSList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMyFiveS = async () => {
      try {
        const response = await fetch(`/fives/getmyall5s?userId=${userId}`);

        if (!response.ok) {
          throw new Error('5S entries not found!');
        }

        const data = await response.json();
        setFiveSList(data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchMyFiveS();
  }, [authState.user._id]);

  const handleAddNew = () => {
    navigate('/fives/add'); 
  };

  const handleEdit = (id) => {
    navigate(`/fives/${id}`); 
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm('Are you sure you want to delete this 5S entry?');
    if (confirmDelete) {
      try {
        const response = await fetch(`/fives/delete/${id}`, {
          method: 'DELETE',
        });

        if (!response.ok) {
          throw new Error('Failed to delete the 5S entry');
        }
        setFiveSList(fiveSList.filter((fiveS) => fiveS._id !== id));
      } catch (err) {
        console.error('Error deleting the 5S entry:', err);
      }
    }
  };

  return (
    <div className='bg-black  [&_p]:text-white'>
      <div className="min-h-[90vh] mx-auto p-4">
        <div className='border-b border-blue-400'>
          <h2 className="text-xl lg:text-2xl py-2 px-4 text-yellow-200">🧹 My 5S Entries</h2>
        </div>
        <div className="flex justify-center mt-8 mb-4">
            <button
              onClick={handleAddNew}
              className="bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-700 w-40"
            >
              + Add New 5S
            </button>
          </div>
        {loading ? (
          <p>Loading...</p>
        ) : error ? (
          <p className="text-yellow-200 flex *:text-center justify-center ">{error}</p>
        ) : fiveSList.length === 0 ? (
          <div className="flex justify-center mt-8 mb-4">
            <p className='flex items-center justify-center text-center'>No 5S entries found.</p>
            <button
              onClick={handleAddNew}
              className="bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-700 w-40"
            >
              + Add New 5S
            </button>
          </div>
        ) : (
          <div className="flex justify-center mb-4">
          <button
            onClick={handleAddNew}
            className="bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-700 w-40"
          >
            + Add New 5S
          </button>

          <table className="table-auto w-full border-collapse border border-gray-300">
            <thead>
              <tr className="bg-gray-200">
                <th className="border px-4 py-2">User Code</th>
                <th className="border px-4 py-2">User Name</th>
                <th className="border px-4 py-2">Date Created</th>
                <th className="border px-4 py-2">S1 (Sort)</th>
                <th className="border px-4 py-2">S2 (Set in Order)</th>
                <th className="border px-4 py-2">S3 (Shine)</th>
                <th className="border px-4 py-2">S4 (Standardize)</th>
                <th className="border px-4 py-2">S5 (Sustain)</th>
                <th className="border px-4 py-2">Comments</th>
                <th className="border px-4 py-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              {fiveSList.map((fiveS) => (
                <tr key={fiveS._id}>
                  <td className="border px-4 py-2">{fiveS.userCode}</td>
                  <td className="border px-4 py-2">{fiveS.userName}</td>
                  <td className="border px-4 py-2">{new Date(fiveS.dateCreated).toLocaleDateString()}</td>
                  <td className="border px-4 py-2">{fiveS.s1}</td>
                  <td className="border px-4 py-2">{fiveS.s2}</td>
                  <td className="border px-4 py-2">{fiveS.s3}</td>
                  <td className="border px-4 py-2">{fiveS.s4}</td>
                  <td className="border px-4 py-2">{fiveS.s5}</td>
                  <td className="border px-4 py-2">{fiveS.comments}</td>
                  <td className="border px-4 py-2 flex justify-center">
                   <FontAwesomeIcon icon={faPen} className="text-yellow-500 text-xl ml-3" 
                      title="Edit"
                      onClick={() => handleEdit(fiveS._id)}
                    />
                    <FontAwesomeIcon icon={faTrash} className="text-yellow-500 text-xl ml-3"
                      title="Delete"
                      onClick={() => handleDelete(fiveS._id)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        )}
      </div>
      <footer className="bg-[#2a0f2f] border-t border-blue-800 text-blue-300 py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-xs lg:text-sm">
            © 2025 Think5Whys Global DeepTech Solutions.
          </div>
          <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
            <Link to="/about-us" className="text-white hover:text-blue-400">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-blue-400">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-blue-400">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-blue-400">Contact</Link>
          </div>
        </div>
      </footer>      
    </div>
  );
};

export default MyFiveSMyList;
